import { render, staticRenderFns } from "./MacroPreview.vue?vue&type=template&id=45b9dd4a&scoped=true&"
import script from "./MacroPreview.vue?vue&type=script&lang=js&"
export * from "./MacroPreview.vue?vue&type=script&lang=js&"
import style0 from "./MacroPreview.vue?vue&type=style&index=0&id=45b9dd4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b9dd4a",
  null
  
)

export default component.exports